// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import Modal from 'react-modal'
import { ProjectCreate } from 'components'

const wrapperStyles = {
  borderLeft: '1px solid',
  marginRight: 'auto',
  paddingLeft: '1em',
}

const buttonStyles = {
  border: '1px solid',
  lineHeight: '24px',
  minWidth: 0,
  padding: '0 .5em',
}

class NewProject extends React.Component {
  state = {
    isOpen: false,
  }

  toggleModal = () => (
    this.setState(({ isOpen }) => ({
      isOpen: !isOpen,
    }))
  )

  render () {
    const {
      state: { isOpen },
      toggleModal,
    } = this

    return (
      <div
        className={'create-button'}
        style={wrapperStyles}>
        <p
          className={'border-radius-1 bg-blue text-white btn center-text hover-inverse pointer uppercase padding-half heading-font'}
          id={'new-project-modal-trigger'}
          onClick={toggleModal}
          style={buttonStyles}>
          <i className={'fa fa-plus padding-right-half'} />
          <span>{'Create'}</span>
        </p>
        <Modal
          className={'modal-content-default'}
          closeModal={toggleModal}
          contentLabel={'New Project Modal'}
          isOpen={isOpen}
          onRequestClose={toggleModal}
          overlayClassName={'modal-overlay-default'}>
          <div id={'new-project-modal-body'}>
            <span
              id={'home-newProjectModalClose'}
              className={'pull-right pointer'}
              onClick={toggleModal}>
              {'X'}
            </span>
            <h3
              id={'newProjectForm-heading'}
              className={'uppercase'}>
              {'Create New Project'}
            </h3>
            <ProjectCreate />
          </div>
        </Modal>
      </div>
    )
  }
}

export default NewProject
